import React from 'react';
import DesktopDevPageSide300x250Gak from './gak/DesktopDevPageSide300x250';
const DesktopDevPageSide300x250 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Gak, {
        safety: safety
    });
};
DesktopDevPageSide300x250.displayName = 'DesktopDevPageSide300x250';
export default DesktopDevPageSide300x250;
